module.exports = "<!-- <app-header></app-header>\n<app-level1menu></app-level1menu>\n<router-outlet></router-outlet> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/homepage/homepage.component.html
// module id = ./src/app/homepage/homepage.component.html
// module chunks = main